import { FC } from 'react';

export type InfoCellProps = { description?: string; title: string | undefined };

export const InfoCell: FC<InfoCellProps> = ({ description, title }) => (
  <div className="flex flex-col">
    <span className="text-sm font-[450] leading-5 text-gray-700">{title}</span>
    {description && (
      <span className="text-[10px] font-medium leading-4 text-gray-500">{description}</span>
    )}
  </div>
);
